import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { useMediaQuery } from '@material-ui/core';

import moment from 'moment';

import { useTitular } from '../../../contexts/InclusaoTitular/context';
import { useDependente } from '../../../contexts/InclusaoDependente/context';
import { useGlobal } from '../../../contexts/Global/context';
import { useAposentadosDemitidos } from '../../../contexts/AposentadosDemitidos/context';

import Icon from '../../../components/Icons';
import Input from '../../../components/Inputs/Input';
import Button from '../../../components/Button';
import Modal from '../../../components/Modal';
import DatepickerRange from '../../../components/Inputs/DatepickerRange';
import Select from '../../../components/Inputs/Select';
import PageLoader from '../../../components/PageLoader';
import DataTableMui from '../../../components/DataTableMui';

import CustomStatusTag from './CustomStatusTag';
import filterSchema from './schema';
import options from './options';
import createDraftRow from './createDraftRow';

import * as translations from './translations';

import { checkIsSupport, cloneObject, handleTopCritics } from '../../../utils';

import {
    movimentacoesPendentes,
    dadosMovimentacaoPendente,
    buscarRascunhoPeriodo,
    removerRascunho,
    getMunicipios,
    buscaDados,
    dadosBeneficiarioReativar,
    buscaBeneficiarioReativar,
} from '../../../services';

import * as S from './styles';

function MovimentacoesPendentes({ location: { graphFilter } }) {
    const flowLabel = {
        selecionar_titular: 'Adicionar dependente',
        adicionar_titular: 'Adicionar titular',
        aposentados_demitidos: 'Aposentados e demitidos',
    };

    const { dataActiveContract, contrastTheme, setShowSupportModal } = useGlobal();
    const { setDataDependentes } = useDependente();
    const { setDataTitular, setFlow, setOthersDocuments, setAlerts } = useTitular();
    const {
        clearAposentadosDemitidos,
        dataAposentadosDemitidos,
        setDataAposentadosDemitidos,
        setDataBeneficiario,
        setDataContrato,
        setDataInputForm,
    } = useAposentadosDemitidos();

    const history = useHistory();

    const matchMediaQuery = useMediaQuery('(max-width: 960px)');

    const [filterValues, setFilterValues] = useState(cloneObject(filterSchema));
    const [loading, setLoading] = useState(true);
    const [alreadySearched, setAlreadySearched] = useState(false);
    const [showModalTrash, setShowModalTrash] = useState(false);
    const [showModalAnalysis, setShowModalAnalysis] = useState(false);
    const [movimentacoes, setMovimentacoes] = useState([]);
    const [dataTable, setDataTable] = useState([]);
    const [modalAlerta, setModalAlerta] = useState([]);
    const [selectedRow, setSelectedRow] = useState({});
    const [showFilters, setShowFilters] = useState(true);
    const [pageLoading, setPageLoading] = useState(false);
    const [rangeLimits, setRangeLimits] = useState({
        min: filterSchema.movementDate.value[0],
        max: filterSchema.movementDate.value[1],
    });

    function RenderTrashIcon(props) {
        return (
            <S.DeleteDrawContainer {...props}>
                <Icon color={contrastTheme ? '#FFF333' : '#EC6E0C'} name="delete" />
            </S.DeleteDrawContainer>
        );
    }

    async function handleClickRow(row) {
        setPageLoading(true);
        setModalAlerta({ message: '', visible: false });

        // Rascunho
        if (row.status === 2) {
            const rascunho = row.dataSet;

            if (rascunho.flow === 'aposentados_demitidos') {
                setDataAposentadosDemitidos({
                    ...dataAposentadosDemitidos,
                    situacao: rascunho?.dataInputForm?.situation?.value,
                });

                setDataContrato(dataActiveContract);

                setDataBeneficiario(rascunho.dataBeneficiario);

                setDataInputForm(rascunho.dataInputForm);

                history.push('/movimentacao_cadastral/carregar_documentos_aposentados_demitidos');

                return;
            }

            setDataTitular(rascunho.dataTitular);

            setDataDependentes(rascunho.dataDependentes);

            setFlow(rascunho.flow);

            setOthersDocuments(rascunho.othersDocuments);

            history.push('/movimentacao_cadastral/upload_documentos');

            return;
        }

        if (row.status === 4 || row.status === 7) {
            const { typeTranslation, pathFlow, numSequencialMovimentacao, observacaoAnalise, motivosRecusa } = row;

            const rootPath = '/movimentacao_cadastral';

            let dataForm = {};

            const dadosMovimentacao = await dadosMovimentacaoPendente(numSequencialMovimentacao);

            if (dadosMovimentacao.status === 400 && dadosMovimentacao.data.message) {
                setModalAlerta({ message: dadosMovimentacao.data.message, visible: true });
                setPageLoading(false);
                return;
            }

            const criticas = handleTopCritics(dadosMovimentacao.criticas);

            if (motivosRecusa.length > 0) {
                criticas.unshift({
                    tipo: 1,
                    descricao: `Motivo da recusa: ${motivosRecusa[0].descricaoMotivoDevolucao}`,
                    complemento: observacaoAnalise,
                    codigo: '#TOP_OBS_ERROR',
                });
            }

            if (typeTranslation === 'reativacao') {
                const payload = [dadosMovimentacao.reativacao.numeroAssociado, dataActiveContract.numero];

                const dadosBeneficiario = await dadosBeneficiarioReativar(...payload);
                const buscaBeneficiario = await buscaBeneficiarioReativar(...payload);

                dadosMovimentacao.dados = {
                    ...dadosMovimentacao.reativacao,
                    ...dadosBeneficiario,
                    ...buscaBeneficiario[0],
                };
            }

            if (typeTranslation && typeof translations[typeTranslation] === 'function') {
                dataForm = translations[typeTranslation](dadosMovimentacao.dados);
            }

            if (typeTranslation === 'inclusaoTitular') {
                let municipios = [];

                if (dataForm.uf.value) {
                    municipios = await getMunicipios(dataForm.uf.value);
                }

                setDataTitular({
                    ...dataForm,
                    city: { ...dataForm.city, options: municipios },
                });

                setFlow('adicionar_titular');

                setAlerts(criticas);

                history.push({
                    pathname: `${rootPath}${pathFlow}`,
                    cameFrom: 'movimentacoes_pendentes',
                });

                return;
            }

            if (typeTranslation === 'inclusaoDependente') {
                setDataTitular(dataForm.dadosTitular || {});

                setDataDependentes(dataForm.dadosDependente || []);

                setFlow('selecionar_titular');

                setAlerts(criticas);

                history.push({
                    pathname: `${rootPath}${pathFlow}`,
                });

                return;
            }

            if (typeTranslation === 'alteracaoCadastral') {
                let dataTitular = {};

                if (['dependente', 'agregado'].includes(dataForm.tipo.toLowerCase())) {
                    const responseTitular = await buscaDados(dataForm.cpfTitular, dataActiveContract.numero);

                    dataTitular = responseTitular.find((titular) => titular.situacao !== 'EXCLUIDO');
                }

                history.push({
                    pathname: `${rootPath}${pathFlow}${dataForm.tipo.toLowerCase()}`,
                    dataBeneficiario: dataForm,
                    dataTitular,
                    criticas,
                });

                return;
            }

            if (typeTranslation === 'aposentadosDemitidos') {
                clearAposentadosDemitidos();

                history.push({
                    pathname: `${rootPath}${pathFlow}`,
                    beneficiario: dadosMovimentacao.dados.busca[0],
                    dataMovimentacao: dataForm,
                    criticas,
                });

                return;
            }

            if (typeTranslation === 'reativacao') {
                history.push({
                    pathname: `${rootPath}/reativar_beneficiario`,
                    dataBeneficiario: dataForm,
                    criticas,
                });

                return;
            }

            history.push({
                pathname: `${rootPath}${pathFlow}`,
                dataBeneficiario: dataForm,
                dataMovimentacaoPendente: dataForm,
                criticas,
            });
        }
    }

    const rowMutation = {
        class: (row) => {
            if (row.status === 3) return 'in-analysis-pending-move';
            return '';
        },
        click: (row) => {
            switch (row.status) {
                case 2:
                    handleClickRow(row);
                    break;
                case 3:
                    setSelectedRow(row);
                    setShowModalAnalysis(true);
                    break;
                case 4:
                    handleClickRow(row);
                    break;
                case 7:
                    handleClickRow(row);
                    break;
                default:
            }
        },
        hasClick: (row) => {
            if (row.status === 3 || row.status === 4 || row.status === 2 || row.status === 7) return true;
            return false;
        },
    };

    const handleRowDeleteDraft = (event, value) => {
        event.stopPropagation();

        if (checkIsSupport()) {
            setShowSupportModal(true);
            return;
        }

        setSelectedRow(value);

        setShowModalTrash(true);
    };

    const columnsHead = [
        {
            key: 'numCarteirinha',
            selector: (row) => row.numCarteirinha || '-',
            name: 'Nº da carteirinha',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ padding: '0 16px 0 24px', width: '200px' }),
        },
        {
            key: 'protocolo',
            selector: (row) => row.protocolo || '-',
            name: 'Protocolo',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: '200px' }),
        },
        {
            key: 'nomeCompleto',
            selector: (row) => row.nomeCompleto || '-',
            name: 'Nome completo',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: 'calc(100% - 700px)', height: '60px' }),
        },
        {
            key: 'tipoOperacao',
            selector: (row) => row.tipoOperacao,
            name: 'Tipo de operação',
            sortable: true,
            direction: 'center',
            customStyles: () => ({ width: '200px' }),
        },
        {
            key: 'status',
            selector: (row) => row.status,
            name: 'Status',
            sortable: true,
            direction: 'center',
            mutation: (value) => <CustomStatusTag status={value} />,
            customStyles: () => ({ width: '122px', padding: '18px 16px' }),
            customClassName: 'status-column',
        },
        {
            key: 'actions',
            selector: (row) => row,
            name: '',
            sortable: false,
            direction: 'right',
            mutation: (value) => {
                if (value.status === 2)
                    return <Icon name="delete" onClick={(event) => handleRowDeleteDraft(event, value)} />;
                return '';
            },
            customStyles: () => ({
                width: '43px',
                cursor: 'pointer',
                zIndex: '9999',
                padding: '0',
            }),
        },
    ];

    async function handleDeleteRascunho(row) {
        const { cpfCnpj, numeroContrato } = row;

        const payload = {
            cpfCnpj,
            numeroContrato,
        };

        const response = await removerRascunho(payload);

        if (response === 200) {
            const indexDeleted = movimentacoes.findIndex(
                (mov) => mov.cpfCnpj === cpfCnpj && mov.numeroContrato === numeroContrato
            );

            const newMovimentacoes = [...movimentacoes];

            newMovimentacoes.splice(indexDeleted, 1);

            setMovimentacoes([...newMovimentacoes]);
            setDataTable([...newMovimentacoes]);
        }
        setShowModalTrash(false);
    }

    function treatResponseData(list) {
        return list.map((row) => {
            const operacao = options.operacoes.find((op) => +op.codigo === +row.operacao);

            return {
                ...row,
                tipoOperacao: operacao?.nome,
                typeTranslation: operacao?.tipoTraducao,
                pathFlow: operacao?.path,
            };
        });
    }

    function treatRascunhos(list) {
        return list.map((row) => ({
            ...createDraftRow({ row, flowLabel }),
            icon: (
                <RenderTrashIcon
                    onClick={() => {
                        setSelectedRow({ ...row });
                        setShowModalTrash(true);
                    }}
                />
            ),
        }));
    }

    function handleChangeFilter(event) {
        const { id, value, draftFlow } = event;

        const field = cloneObject({ ...filterValues[id], value, error: '', draftFlow });

        setFilterValues({
            ...filterValues,
            [id]: field,
        });
    }

    async function handleSearch(filters) {
        if (filters.nativeEvent) {
            filters = filterValues;
        }

        setAlreadySearched(false);

        setLoading(true);

        const { movementDesc, movementProtocol, movementStatus, movementType } = filters;
        const [dateStart, dateEnd] = filters.movementDate.value || [];

        const isSearchingOnlyDrafts = +movementStatus.value === 2;

        let newRascunhos = [];

        const responsePendentes =
            !isSearchingOnlyDrafts || !movementStatus.value
                ? (await movimentacoesPendentes({
                      numContrato: dataActiveContract.numero,
                      dtInicioPeriodo: dateStart,
                      dtFimPeriodo: dateEnd,
                      offset: 0,
                      limit: 100,
                      nomeCarteira: movementDesc.value?.trim(),
                      protocolo: movementProtocol.value?.trim(),
                      status: movementStatus.value,
                      operacao: movementType.value,
                  })) || []
                : [];

        if (!movementStatus.value || +movementStatus.value === 2) {
            const resRascunho =
                (await buscarRascunhoPeriodo({
                    numeroContrato: dataActiveContract.numero,
                    dtInicio: moment(dateStart).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toISOString(),
                    dtFim: moment(dateEnd)
                        .add(1, 'days')
                        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
                        .toISOString(),
                })) || [];

            const dataRascunhos = treatRascunhos(resRascunho);

            newRascunhos = dataRascunhos.filter(
                ({ nomeCompleto, flow }) =>
                    !movementProtocol.value &&
                    (movementDesc.value
                        ? nomeCompleto.toLowerCase().includes(movementDesc.value.toLowerCase())
                        : true) &&
                    (movementType.value ? movementType.draftFlow === flow : true) &&
                    (movementStatus.value ? movementStatus.value === '2' : true)
            );
        }

        const treatedResponse = treatResponseData(responsePendentes);
        const dataGrid = [...newRascunhos, ...treatedResponse];

        setMovimentacoes(dataGrid);

        setDataTable(dataGrid);

        setLoading(false);

        setAlreadySearched(true);
    }

    function handleChangeRange(date, _, { range }) {
        if (!date) {
            setRangeLimits({
                min: '',
                max: '',
            });

            return;
        }

        const cloneDate = cloneObject(date);

        if (range === 'start') {
            setRangeLimits({
                ...rangeLimits,
                max: moment(cloneDate[0]).add(30, 'days'),
            });
        }

        if (range === 'end') {
            setRangeLimits({
                ...rangeLimits,
                min: moment(cloneDate[1]).subtract(30, 'days'),
            });
        }
    }

    useEffect(() => {
        if (graphFilter) {
            const { statusValue, dateRange } = graphFilter;

            const preSelectedFilters = {
                ...filterValues,
                movementDate: {
                    ...filterValues.movementDate,
                    value: dateRange,
                },
                movementStatus: {
                    ...filterValues.movementStatus,
                    value: statusValue,
                },
            };

            setFilterValues(preSelectedFilters);

            handleSearch(preSelectedFilters);

            return;
        }

        handleSearch(filterValues);
    }, []);

    return (
        <>
            <S.SectionContainer style={{ padding: '32px 32px 0' }}>
                {matchMediaQuery && (
                    <S.ToogleButton onClick={() => setShowFilters(!showFilters)}>
                        <Icon name="filter_alt" />
                        <spam style={{ textDecoration: 'underline' }}>Filtrar</spam>
                    </S.ToogleButton>
                )}

                <S.FirstColumn showFilters={!matchMediaQuery || showFilters}>
                    <S.Row>
                        <Input
                            field={{
                                ...filterValues.movementDesc,
                                icon: { name: 'search', type: 'round' },
                            }}
                            onChange={(event) => handleChangeFilter(event)}
                        />

                        <Input field={filterValues.movementProtocol} onChange={(event) => handleChangeFilter(event)} />
                    </S.Row>

                    <S.Row>
                        <DatepickerRange
                            field={filterValues.movementDate}
                            disabledDate={(d) => !d || d.isAfter(rangeLimits.max) || d.isSameOrBefore(rangeLimits.min)}
                            onCalendarChange={handleChangeRange}
                            onChange={(event) => handleChangeFilter(event)}
                        />

                        <Select
                            field={{
                                ...filterValues.movementType,
                                options: options.operacoes,
                            }}
                            onChange={(event) => handleChangeFilter(event)}
                        />

                        <Select
                            field={{
                                ...filterValues.movementStatus,
                                options: options.statusGroup,
                            }}
                            onChange={(event) => handleChangeFilter(event)}
                        />
                    </S.Row>
                </S.FirstColumn>

                <S.SecondColumn showFilters={!matchMediaQuery || showFilters}>
                    <Button disabled={loading} onClick={handleSearch}>
                        Pesquisar
                    </Button>
                </S.SecondColumn>
            </S.SectionContainer>

            <S.TableContainer contrastTheme={contrastTheme}>
                <S.TextoResultado>Resultados</S.TextoResultado>

                <DataTableMui
                    clickableRow
                    data={dataTable}
                    emptyMessage="Não encontramos esse beneficiário. Você pode fazer uma nova pesquisa."
                    loading={loading}
                    columns={columnsHead}
                    alreadySearched={alreadySearched}
                    rowMutation={rowMutation}
                    firstOrderBy="numCarteirinha"
                />
            </S.TableContainer>

            {showModalTrash ? (
                <Modal
                    title="Você quer excluir o rascunho?"
                    subtitle="O rascunho será definitivamente excluído da plataforma."
                    modalSize="sm"
                    visible={showModalTrash}
                    onCancel={() => setShowModalTrash(false)}
                    footer={null}
                >
                    <Button type="secondary" onClick={() => setShowModalTrash(false)}>
                        Não quero
                    </Button>
                    <Button type="primary" onClick={() => handleDeleteRascunho(selectedRow)}>
                        Sim, quero
                    </Button>
                </Modal>
            ) : null}

            {showModalAnalysis ? (
                <Modal
                    title="Em análise"
                    subtitle="A operadora está analisando a sua solicitação. Por favor, aguarde."
                    modalSize="sm"
                    visible={showModalAnalysis}
                    onCancel={() => setShowModalAnalysis(false)}
                    footer={null}
                >
                    <Button type="primary" onClick={() => setShowModalAnalysis(false)}>
                        Entendi
                    </Button>
                </Modal>
            ) : null}

            <Modal
                title="Atenção"
                subtitle={modalAlerta.message}
                modalSize="sm"
                visible={modalAlerta.visible}
                onCancel={() => setModalAlerta({ message: '', visible: false })}
                footer={null}
            >
                <Button type="primary" onClick={() => setModalAlerta({ message: '', visible: false })}>
                    Entendi
                </Button>
            </Modal>

            <PageLoader loading={pageLoading} />
        </>
    );
}

export default MovimentacoesPendentes;
